import React from "react"
import { Field, useFormikContext } from "formik"
import { getInNested } from "../dynamic-form.helper"
import "./input-radio-cards.scss"

// Single-select "card" radio group for rich option choices (title + badge +
// subtitle + description). Binds via Formik <Field type="radio"> exactly like
// InputRadio, so value get/set and validation are identical — only the
// presentation differs. Single-select only (no "Other" free-text handling).
function InputRadioCards(props) {
  const { id, label, name, optionData, errorMessage, fieldData, isNestedFieldName, isRequired } = props
  const { values, touched, errors } = useFormikContext()
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`
  const selectedValue = getInNested(values, name, isNestedFieldName)
  const options = Array.isArray(optionData) ? optionData : []

  return (
    <div className="custom-form-block c-radio-cards-block">
      <fieldset disabled={fieldData?.enabled === false}>
        {label && (
          <label htmlFor={id} className="form-label mt-2">
            {label} {isRequired && <sup>*</sup>}
          </label>
        )}
        <div className="c-radio-cards" role="radiogroup" aria-label={label || name}>
          {options.map((option, index) => {
            const selected = selectedValue === option.value
            const optionId = `option-${id}-${index}`
            return (
              <label key={optionId} htmlFor={optionId} className={`c-radio-card${selected ? " is-selected" : ""}`}>
                <Field
                  type="radio"
                  name={normalizedNameKey}
                  id={optionId}
                  className="c-radio-card__input"
                  value={option.value}
                  checked={selected}
                />
                <span className="c-radio-card__radio" aria-hidden="true" />
                <span className="c-radio-card__body">
                  <span className="c-radio-card__head">
                    <span className="c-radio-card__title">{option.title || option.display}</span>
                    {option.badge && <span className="c-radio-card__badge">{option.badge}</span>}
                  </span>
                  {option.subtitle && <span className="c-radio-card__subtitle">{option.subtitle}</span>}
                  {option.description && <span className="c-radio-card__desc">{option.description}</span>}
                </span>
              </label>
            )
          })}
        </div>
        <div className="invalid-feedback">
          {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
        </div>
      </fieldset>
    </div>
  )
}

export default InputRadioCards
